<template>
  <div>
    <div class="bg-blue-900 lg:p-10">
      <div class="container max-w-2xl p-5">
        <a href="http://cffp.recherche.usherbrooke.ca/">
          <img
            class="w-48 mx-auto mb-10"
            src="@/assets/logo.png"
            alt="Logo chaire de recherche en fiscalité et finances publiques de l'Université de Sherbrooke"
          >
        </a>
        <p class="mb-1 text-3xl font-bold leading-tight text-blue-100 lg:text-4xl">
          Life stories
        </p>
        <p class="mb-8 leading-tight text-blue-300 lg:text-2xl">
          How do tax levies, social benefits and government spending evolve for a taxpayer over the course of their life?
        </p>
      </div>
      <div class="container max-w-2xl bg-blue-100">
        <div class="p-8 lg:p-10">
          <p class="mb-10">
            We will be following the life of Ella, who exhibits the typical features of a young Quebec woman, from her <b>18th birthday</b> until her death at <b>87 years old</b>, through three distinctive life scenarios: 
          </p>
          <div class="mb-10">
            <div class="pl-6 mb-10 border-l-4 border-blue-500">
              <div class="flex items-baseline mb-3">
                <h2 class="mr-4 text-lg font-bold lg:text-xl">
                  Scenario 1
                </h2>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="65.649"
                  height="86.892"
                  viewBox="0 0 65.649 86.892"
                  class="w-auto h-4 text-blue-700"
                ><g transform="translate(-147.54 -111.445)"><g transform="translate(147.54 162.719)"><path
                  d="M198.988,285.357a27.077,27.077,0,0,0-13.02-3.312H174.761a27.215,27.215,0,0,0-27.221,27.221v8.4h65.649v-8.4A27.211,27.211,0,0,0,198.988,285.357Z"
                  fill="currentColor"
                  transform="translate(-147.54 -282.045)"
                /></g><g transform="translate(159.279 111.445)"><g transform="translate(0)"><path
                  d="M207.687,111.445c-11.628,0-21.087,9.993-21.087,22.28a22.423,22.423,0,0,0,12.073,20.137,20.053,20.053,0,0,0,18.027,0,22.423,22.423,0,0,0,12.073-20.137C228.773,121.438,219.315,111.445,207.687,111.445Z"
                  fill="currentColor"
                  transform="translate(-186.6 -111.445)"
                /></g></g></g></svg>
              </div>

              <p class="">
                Ella lives alone, without children, throughout her whole life.
              </p>
            </div>
            <div class="pl-6 mb-10 border-l-4 border-blue-500">
              <div class="flex items-baseline mb-3">
                <h2 class="mr-4 text-lg font-bold lg:text-xl">
                  Scenario 2
                </h2>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="253.626"
                  height="86.892"
                  viewBox="0 0 253.626 86.892"
                  class="w-auto h-4 text-blue-700"
                ><g transform="translate(-291.321 -142.218)"><g transform="translate(143.781 30.773)"><g transform="translate(147.54 162.719)"><path
                  d="M198.988,285.357a27.077,27.077,0,0,0-13.02-3.312H174.761a27.215,27.215,0,0,0-27.221,27.221v8.4h65.649v-8.4A27.211,27.211,0,0,0,198.988,285.357Z"
                  transform="translate(-147.54 -282.045)"
                  fill="currentColor"
                /></g><g transform="translate(159.279 111.445)"><g transform="translate(0)"><path
                  d="M207.687,111.445c-11.628,0-21.087,9.993-21.087,22.28a22.423,22.423,0,0,0,12.073,20.137,20.053,20.053,0,0,0,18.027,0,22.423,22.423,0,0,0,12.073-20.137C228.773,121.438,219.315,111.445,207.687,111.445Z"
                  transform="translate(-186.6 -111.445)"
                  fill="currentColor"
                /></g></g></g><g transform="translate(218.781 30.773)"><g transform="translate(147.54 162.719)"><path
                  d="M198.988,285.357a27.077,27.077,0,0,0-13.02-3.312H174.761a27.215,27.215,0,0,0-27.221,27.221v8.4h65.649v-8.4A27.211,27.211,0,0,0,198.988,285.357Z"
                  transform="translate(-147.54 -282.045)"
                  fill="currentColor"
                /></g><g transform="translate(159.279 111.445)"><g transform="translate(0)"><path
                  d="M207.687,111.445c-11.628,0-21.087,9.993-21.087,22.28a22.423,22.423,0,0,0,12.073,20.137,20.053,20.053,0,0,0,18.027,0,22.423,22.423,0,0,0,12.073-20.137C228.773,121.438,219.315,111.445,207.687,111.445Z"
                  transform="translate(-186.6 -111.445)"
                  fill="currentColor"
                /></g></g></g><g transform="translate(441.321 166.944)"><g transform="translate(0 36.683)"><path
                  d="M184.348,284.415a19.372,19.372,0,0,0-9.315-2.37h-8.018A19.471,19.471,0,0,0,147.54,301.52v6.008h46.968V301.52A19.468,19.468,0,0,0,184.348,284.415Z"
                  transform="translate(-147.54 -282.045)"
                  fill="currentColor"
                /></g><g transform="translate(8.399 0)"><g transform="translate(0)"><path
                  d="M201.686,111.445c-8.319,0-15.086,7.15-15.086,15.94a16.042,16.042,0,0,0,8.638,14.407,14.346,14.346,0,0,0,12.9,0,16.042,16.042,0,0,0,8.638-14.407C216.772,118.595,210.006,111.445,201.686,111.445Z"
                  transform="translate(-186.6 -111.445)"
                  fill="currentColor"
                /></g></g></g><g transform="translate(497.979 166.944)"><g transform="translate(0 36.683)"><path
                  d="M184.348,284.415a19.372,19.372,0,0,0-9.315-2.37h-8.018A19.471,19.471,0,0,0,147.54,301.52v6.008h46.968V301.52A19.468,19.468,0,0,0,184.348,284.415Z"
                  transform="translate(-147.54 -282.045)"
                  fill="currentColor"
                /></g><g transform="translate(8.399 0)"><g transform="translate(0)"><path
                  d="M201.686,111.445c-8.319,0-15.086,7.15-15.086,15.94a16.042,16.042,0,0,0,8.638,14.407,14.346,14.346,0,0,0,12.9,0,16.042,16.042,0,0,0,8.638-14.407C216.772,118.595,210.006,111.445,201.686,111.445Z"
                  transform="translate(-186.6 -111.445)"
                  fill="currentColor"
                /></g></g></g></g></svg>
              </div>
              <p class="">
                Ella starts a relationship at 27, gives birth to two children and remains with her partner until his death, she will then be 82.
              </p>
            </div>
            <div class="pl-6 mb-10 border-l-4 border-blue-500">
              <div class="flex items-baseline mb-3">
                <h2 class="mr-4 text-lg font-bold lg:text-xl">
                  Scenario 3
                </h2>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="121.968"
                  height="86.892"
                  viewBox="0 0 121.968 86.892"
                  class="w-auto h-4 text-blue-700"
                ><g transform="translate(-634.321 -142.218)"><g transform="translate(486.781 30.773)"><g transform="translate(147.54 162.719)"><path
                  d="M198.988,285.357a27.077,27.077,0,0,0-13.02-3.312H174.761a27.215,27.215,0,0,0-27.221,27.221v8.4h65.649v-8.4A27.211,27.211,0,0,0,198.988,285.357Z"
                  transform="translate(-147.54 -282.045)"
                  fill="currentColor"
                /></g><g transform="translate(159.279 111.445)"><g transform="translate(0)"><path
                  d="M207.687,111.445c-11.628,0-21.087,9.993-21.087,22.28a22.423,22.423,0,0,0,12.073,20.137,20.053,20.053,0,0,0,18.027,0,22.423,22.423,0,0,0,12.073-20.137C228.773,121.438,219.315,111.445,207.687,111.445Z"
                  transform="translate(-186.6 -111.445)"
                  fill="currentColor"
                /></g></g></g><g transform="translate(709.321 166.944)"><g transform="translate(0 36.683)"><path
                  d="M184.348,284.415a19.372,19.372,0,0,0-9.315-2.37h-8.018A19.471,19.471,0,0,0,147.54,301.52v6.008h46.968V301.52A19.468,19.468,0,0,0,184.348,284.415Z"
                  transform="translate(-147.54 -282.045)"
                  fill="currentColor"
                /></g><g transform="translate(8.399 0)"><g transform="translate(0)"><path
                  d="M201.686,111.445c-8.319,0-15.086,7.15-15.086,15.94a16.042,16.042,0,0,0,8.638,14.407,14.346,14.346,0,0,0,12.9,0,16.042,16.042,0,0,0,8.638-14.407C216.772,118.595,210.006,111.445,201.686,111.445Z"
                  transform="translate(-186.6 -111.445)"
                  fill="currentColor"
                /></g></g></g></g></svg>
              </div>
              <p class="">
                Ella starts a relationship, gives birth to one child and parts ways with her partner when she reaches 40.  Ella has the sole custody of her minor child and remains single for the rest of her life.
              </p>
            </div>
          </div>
          <p class="">
            The <span class="revenu">income</span>, the <span class="prelevements">levies</span>, the <span class="prestations">financial benefits</span> and the value of the <span class="benefices">public services</span> perceived are presented on an <b>annual basis</b> and represent what is payed and obtained by Ella and, when relevant, by her partner Luis and her minor children. 
          </p>
        </div>
      </div>
    </div>
    <Scrollama
      :offset="0.9"
      class="bg-blue-200"
      @step-enter="stepEnterHandler"
    >
      <notice
        data-max="20"
        data-category="revenu"
        data-tooltip="20,revenu"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          Studying in college | 
          <span class="text-gray-600">18 to 20 years old</span> 
        </h2>
        At <b>18</b>, Ella lives with her parents, studies in college and works part-time. She is not in a relationship yet. In every scenarios, her <span class="revenu">income</span> is identical: a little above <b>$7500</b> per year. 
      </notice>
      <div
        slot="graphic"
        class="h-screen"
      >
        <viz
          ref="viz"
          :filters="filters"
        />
      </div> 
      
      <notice
        data-max="20"
        data-category="prelevements"
        data-tooltip="20,prelevements"
        push-bottom
      >
        During those first years, <span class="prelevements">levies</span> go up to about <b>$1500</b>. 
      </notice>
      <notice
        data-max="20"
        data-category="prelevements"
        data-tooltip="20,prelevements"
        push-bottom
      >
        <span class="prelevements">Consumption taxes</span> represent <b>76%</b> of those levies. 
      </notice>
      <notice
        data-max="20"
        data-category="prestations"
        data-tooltip="20,prestations"
        push-bottom
      >
        In return, Ella perceives close to <b>$600</b> in solidarity <span class="prestations">and GST tax credits</span>.
      </notice>
      <notice
        data-max="20"
        data-category="benefices"
        data-tooltip="20,benefices"
        push-bottom
      >
        The value of the <span class="benefices">public services</span> goes up to <b>$14 000</b>. As Ella is going to cégep, the majority of this value comes from <b>higher education services</b>. 
      </notice>
      <notice
        data-min="21"
        data-max="26"
        data-category="revenu"
        data-tooltip="26,revenu"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          Beginning of career | 
          <span class="mr-1 text-gray-600">21 to 26 years old</span> 
        </h2>
        At 21 years old, Ella leaves her parents’ home and starts working full time. Her starting <span class="revenu">salary</span> is a little over <b>$35,000</b> and progressively increases every year until it reaches <b>$42,000</b> when Ella is 26 years old. 
      </notice>
      <notice
        data-min="21"
        data-max="26"
        data-category="prelevements"
        data-tooltip="26,prelevements"
        push-bottom
      >
        The <span class="prelevements">levies</span> increase proportionally to the income and go from <b>$8,500</b> at the start of Ella’s career up to <b>$11,000</b> when she reaches 26 years old. 
      </notice>
      <notice
        data-min="21"
        data-max="26"
        data-category="prelevements"
        data-tooltip="26,prelevements"
        push-bottom
      >
        <span class="prelevements">Federal and the Quebec income taxes </span> represent <b>about half</b> of those levies. 	
      </notice>
      <notice
        data-min="21"
        data-max="26"
        data-category="prestations"
        data-tooltip="26,prestations"
        push-bottom
      >
        The <span class="prestations">benefits</span> perceived consist of the <span class="prestations">GST and the solidarity tax credit</span>, which represents more than <b>$1,000</b>. Those amounts diminish when Ella’s income increases. 
      </notice>
      <notice
        data-min="21"
        data-max="26"
        data-category="benefices"
        data-tooltip="26,benefices"
        push-bottom
      >
        The average value of the perceived <span class="benefices">public healthcare services</span> is about <span class="whitespace-no-wrap">$2,000</span> per year. This value fluctuates according to the age and settles at <b class="whitespace-no-wrap">$2,700</b> when one is reaching 26 years old.
      </notice>
      <notice
        data-min="27"
        data-max="28"
        data-category="revenu"
        data-scenarios="1,2"
        data-tooltip="28,revenu"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          Life as a couple | 
          <span class="mr-1 text-gray-600">27 to 28 years old</span> 
        </h2>
        At <b>27 years</b> Ella starts a relationship with Luis. Consequently, scenarios 2 and 3 take into account the <span class="revenu">household’s income</span>, which adds up to <b>$93,000</b> when the relationship starts.
      </notice>
      <notice
        data-min="27"
        data-max="28"
        data-category="prelevements"
        data-scenarios="1,2"
        data-tooltip="28,prelevements"
        push-bottom
      >
        <span class="prelevements">Levies</span> paid by Ella and Luis add up to about <b class="whitespace-no-wrap">$26,500</b>.
      </notice>
      <notice
        data-min="27"
        data-max="28"
        data-category="benefices,prestations"
        data-scenarios="1,2"
        data-tooltip="28,benefices"
        push-bottom
      >
        The couple doesn’t perceive any <span class="prestations">benefits</span> at first. The value of the <span class="benefices">public services</span> perceived, which consist exclusively of <span class="benefices">healthcare services</span>, adds up to <b>$4,300</b>. 
      </notice>
      <notice
        data-min="29"
        data-max="29"
        data-category="revenu"
        data-scenarios="1,2"
        data-tooltip="29,revenu"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          Birth of the first child | 
          <span class="mr-1 text-gray-600">29 years old</span> 
        </h2>
        After giving birth to her first child, Ella stops working for about a year in the scenarios 2 and 3. The <span class="revenu">household’s income</span> is then cut by half. 
      </notice>
      <notice
        data-min="29"
        data-max="29"
        data-category="prestations"
        data-scenarios="1,2"
        data-tooltip="29,prestations"
        push-bottom
      >
        The new parents perceive <span class="prestations">benefits</span> from the <span class="prestations">Québec Parental Insurance Plan</span>, which add up to <b>$31,000</b>. A total of <b>$5,000</b> of <span class="prestations">family benefits</span> is also perceived. 
      </notice>
      <notice
        data-min="29"
        data-max="29"
        data-category="prelevements"
        data-scenarios="1,2"
        data-tooltip="29,prelevements"
        push-bottom
      >
        The <span class="prelevements">levies</span> decrease and total <b>$20,500</b>.
      </notice>
      <notice
        data-min="29"
        data-max="29"
        data-category="benefices"
        data-scenarios="1,2"
        data-tooltip="29,benefices"
        push-bottom
      >
        The value of the <span class="benefices">healthcare services</span> perceived by the family the year of the first child’s birth totals about <b>$14,000</b>.
      </notice>
      <notice
        data-min="30"
        data-max="30"
        data-category="benefices,revenu"
        data-scenarios="1,2"
        data-tooltip="30,benefices"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          Back to work | 
          <span class="mr-1 text-gray-600">30 years old</span> 
        </h2>
        When the child reaches 1 year old, Ella is back on the <span class="revenu">job market</span> and <span class="benefices">subsidised childcare services</span> are used. The value of this <span class="benefices">public service</span> amounts to about <b>$10,000</b> per year and per child. 
      </notice>
      <notice
        data-min="31"
        data-max="31"
        data-category="revenu"
        data-scenarios="1"
        data-tooltip="31,revenu"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          Second child | 
          <span class="mr-1 text-gray-600">31 years old</span> 
        </h2>
        At 31 years old, in scenario 2, Elle stops working for another year following the birth of her second child. The couple’s <span class="revenu">income</span> is consequently altered. 
      </notice>
      <notice
        data-min="34"
        data-max="39"
        data-scenarios="1,2"
        data-category="benefices"
        data-tooltip="39,benefices"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold leading-tight">
          Start of kindergarten and primary education of the 2 children (scenario 2), only 1 child (scenario 3) | 
          <span class="mr-1 text-gray-600">34 to 39 years old</span> 
        </h2>
        When Ella reaches <b>34 years old</b>, the first child starts kindergarten and the value of the perceived <span class="benefices">public services</span> diminishes because the use of the <span class="benefices">reduced contribution childcare services program</span> is replaced by the use the <span class="benefices">school childcare services</span> and the <span class="benefices">primary education services</span>. 
      </notice>
      <notice
        data-min="40"
        data-max="40"
        data-category="revenu"
        data-scenarios="2"
        data-tooltip="40,revenu"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          Separation | 
          <span class="mr-1 text-gray-600">40 years old</span> 
        </h2>
        At <b>40 years old</b>, scenario 3 shows the impact of the separation of Ella and her partner Luis. She retains the sole custody of her only child. The income now only consists of Ella’s salary which totals about <b>$53,000</b>.
      </notice>
      <notice
        data-min="40"
        data-max="46"
        data-category="prelevements"
        data-scenarios="2"
        data-tooltip="46,prelevements"
        push-bottom
      >
        In scenario 3, following the separation, the <span class="prelevements">levies</span> amount to about <b>$15,000</b>.
      </notice>
      <notice
        data-min="40"
        data-max="46"
        data-category="prestations"
        data-scenarios="2"
        data-tooltip="46,prestations"
        push-bottom
      >
        In a single-parent situation, Ella’s <span class="prestations">benefits</span> are raised. She now perceives <b>$7,500</b>. 
      </notice>
      <notice
        data-min="47"
        data-max="47"
        data-category="prestations,benefices"
        data-scenarios="1,2"
        data-tooltip="47,prestations"
        data-force-highlight="allocation-cad-enfants,paiement-soutien-enfants,credit-solidarite,credit-tps,service-es"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          The first child reaches the age of legal majority | 
          <span class="mr-1 text-gray-600">47 years old</span> 
        </h2>
        When the first child reaches <b>18 years old</b>, the <span class="prestations">benefits</span> decrease and the value of the <span class="benefices">public services</span> allocated to this child is not taken into account anymore. 
        <br>
        In the scenario where Ella is a single-parent, the <span class="prestations">benefits</span> <b class="whitespace-no-wrap">($7,500)</b> disappear completely and a decrease of the value of the <span class="benefices">public services</span> of about <b class="whitespace-no-wrap">$13,700</b> is then observed. 
      </notice>
      <notice
        data-min="49"
        data-max="49"
        data-category="prestations,benefices"
        data-scenarios="1"
        data-tooltip="49,benefices"
        data-force-highlight="allocation-cad-enfants,paiement-soutien-enfants,service-es"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          The second child reaches the age of legal majority | 
          <span class="mr-1 text-gray-600">49 years old</span> 
        </h2>
        In the case of scenario 2, a second decrease of the <span class="prestations">benefits</span> and of the value of the <span class="benefices">public services</span> perceived is observed when Ella reached <b>49 years old</b>, which is when the second child turns <b>18 years old</b>. 
      </notice>
      <notice
        data-min="60"
        data-max="74"
        data-category="revenu"
        data-tooltip="60,revenu,left"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          Retirement | 
          <span class="mr-1 text-gray-600">60 to 74 years old</span> 
        </h2>
        In every scenarios, Ella retires at <b>60 years old</b>. Luis retires at the same time (scenario 2). The <span class="revenu">income</span> then comes from their private pension fund. It is less substantial than when they were actively working.
      </notice>

      <notice
        data-min="60"
        data-max="74"
        data-category="prestations"
        data-scenarios="1"
        data-tooltip="60,prestations,left"
        push-bottom
      >
        Ella perceives the <span class="prestations">benefits of the Québec Pension Plan</span> at <b>61 years old</b>. In scenario 2, Luis perceives those benefits as soon as he retires. Both of them are granted the <span class="prestations">Old age security Pension</span> at <b>65 years old</b>.    
      </notice>
      
      <notice
        data-min="60"
        data-max="74"
        data-tooltip="60,prelevements,left"
        data-category="prelevements"
        push-bottom
      >
        The <span class="prelevements">levies</span> decrease. The <b>social security contributions</b> collected on the salary are replaced by the <span class="prelevements">contributions to the Quebec prescription drug insurance plan</span> and the contributions to the h<span class="prelevements">ealthcare services fund</span>. 
      </notice>

      <notice
        data-min="75"
        data-max="81"
        data-category="prestations"
        data-tooltip="75,prestations,left"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          Retirement | 
          <span class="mr-1 text-gray-600">75 to 81 years old</span> 
        </h2>
        When she reaches <b>75 years old</b>, Ella starts to perceive the <span class="prestations">tax credit for home-support services for seniors</span>. 
      </notice>

      <notice
        data-min="82"
        data-max="82"
        data-category="benefices,prelevements,revenu"
        data-scenarios="1"
        data-tooltip="82,prelevements,left"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          Death of the partner | 
          <span class="mr-1 text-gray-600">82 years old</span> 
        </h2>
        Luis dies when Ella is <b>82 years old</b> (scenario 2), thus altering the <span class="revenu">income</span>, the values of the <span class="prelevements">levies</span> and of the perceived <span class="benefices">public benefits</span>. 
      </notice>

      <notice
        data-min="83"
        data-max="87"
        data-category="benefices"
        data-tooltip="83,benefices,left"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          End of life | 
          <span class="mr-1 text-gray-600">83 to 87 years old</span> 
        </h2>
        In adulthood, the value of the <span class="benefices">healthcare services</span> perceived increases with age. In the case where Ella lives alone during retirement (scenario 1 and 3), this value increases, starting at a little less than <b> $6,000 </b> at 65 years old to reach more than <b>$28,000</b> at 85 years old. 
      </notice>

      <notice
        data-min="18"
        data-max="87"
        data-amounts="false"
        data-visible-category="prestations,benefices,prelevements"
        data-show-selection="false"
        push-bottom
      >
        <h2 class="mb-2 text-lg font-bold">
          Public benefits and levies over the course of a life
        </h2>
        Over the course of a lifetime, Ella’s 3 households are assisted by <span class="benefices">public services</span>, perceive <span class="prestations">benefits</span> and, in return, they pay <span class="prelevements">levies</span>. We can now observe simultaneously those cash-flows.
      </notice>

      <notice
        data-min="18"
        data-max="87"
        data-amounts="false"
        data-show-selection="false"
        data-show-substraction="true"
        push-bottom
      >
        By calculating the <b>difference between what has been perceived and what has been paid</b>, it is possible to observe if Ella’s household has made any net profit (positive value) or if it is a net contributor (negative value) over the course of a year in particular. 
      </notice>

      <notice
        data-min="29"
        data-max="35"
        data-amounts="false"
        data-scenarios="1,2"
        data-show-substraction="true"
        push-bottom
      >
        In scenarios 2 and 3, we notice <b>the impact of the addition of the children</b> to the household and the <span class="prestations">perceived benefits</span> when they reach preschool age.
      </notice>

      <notice
        data-min="40"
        data-max="46"
        data-amounts="false"
        data-scenarios="2"
        data-show-substraction="true"
        push-bottom
      >
        Following the <b>couple’s separation</b>, the <span class="prestations">public benefits</span> perceived by the single-parent family (scenario 3) exceed the <span class="prelevements">levies</span> until the child reaches 18 years old. 
      </notice>

      <notice
        data-min="61"
        data-max="87"
        data-amounts="false"
        data-show-substraction="true"
        push-bottom
      >
        In every scenarios, Ella’s households are net <span class="prestations">beneficiaries</span> from the moment she perceives the <span class="prestations">Québec Pension Plan benefits</span>. 
      </notice>

      <notice
        data-min="18"
        data-max="87"
        data-amounts="false"
        data-show-cumul="true"
        data-show-selection="false"
        push-bottom
      >
        The <b>annual accumulation of the benefits and levies</b> allows us to evaluate, for a specific year, the cumulative difference between, on one hand, the amount of the <span class="prestations">benefits</span> and <span class="benefices">public services</span> perceived during adult life and, on the other hand, the amount of <span class="prelevements">levies</span> paid. 
      </notice>

      <notice
        data-min="18"
        data-max="87"
        data-amounts="false"
        data-show-cumul="true"
        data-show-selection="false"
        push-bottom
      >
        The <b>presence of children</b> and the <b>public benefits offered to two retired individuals rather than one</b>, as a result, allows to pre-empt the moment where Ella’s household starts to retrospectively obtain more than what they paid over the course of an entire lifetime.
        <br>
        <br>
        This moment happens when Ella reaches:
        <ul class="ml-5 list-disc">
          <li><b>74 years old</b> for scenario 2</li>
          <li>
            <b>80 years old</b> for scenario 3
          </li>
          <li><b>85 years old</b> for scenario 1</li>
        </ul>
      </notice>

      <notice
        data-min="18"
        data-max="87"
        data-amounts="false"
        data-show-cumul="true"
        data-show-selection="false"
        push-bottom
      >
        Generally speaking, the <span class="prelevements">levies</span> dominate during <b>working life</b> while the value of the <span class="prestations">public benefits</span> is more important during <b>retirement</b>. 
        <br>
        <br>
        Ella bears an important fiscal burden at certain points in her life without always obtaining an equivalent compensation through public benefits, however, in her case, this situation is temporary. 
      </notice>

      <notice
        v-show="isDesktop"
        data-step="end"
      >
        <h2 class="mb-2 text-lg font-bold">
          Your turn to explore!
        </h2>
        You can now explore the data as you please. The information related to a singular year will appear when you point the cursor on the graphs.
      </notice>

      <div data-step="end">
        <span class="text-transparent">.</span>
      </div>
    </Scrollama>
    <viz-interactive
      v-if="isDesktop"
      ref="vizInteractive"
    />
    <div class="px-6 py-12 bg-blue-100">
      <div class="container max-w-2xl">
        <h2 class="mb-3 text-lg font-semibold">
          Methodology and interpretation
        </h2>
        <p class="mb-5 text-base">
          All calculations are based on the tax systems in force in Quebec for 2018, the household living their whole life in this fiscal system. The majority of the characteristics of our protagonists are based on data issued by Statistics Canada. For each of the parameters, the median parameter (or mean) is used in order to base the analysis on a situation as representative and plausible as possible. It is important to note that only a sample of publics services and therefore of public benefits is represented. Similarly, certain levies, like property taxes haven’t been taken into account.
        </p>
        <p class="mb-5 text-base">
          Therefore, this analysis shouldn’t be considered as a precise assessment of the gains and benefits in Quebec society for a defined life path, but more so as a representation of the evolution of levies and public benefits over a life’s course.
        </p>
        <p class="text-base ">
          The hypothesises on which the entire calculations are based can be found at the following address: <a
            class="text-blue-700 underline"
            href="http://cffp.recherche.usherbrooke.ca/impots-et-services-publics-approche-par-recit-de-vie/"
          >http://cffp.recherche.usherbrooke.ca/impots-et-services-publics-approche-par-recit-de-vie/</a>.
        </p>

        <a
          href="#"
          class="inline-flex items-center px-2 py-2 pr-4 mt-8 bg-gray-200 rounded"
        > 
          <svg
            class="inline"
            style="width:24px;height:24px"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"
            />
          </svg>
          <span class="ml-1">Return to top</span>
        </a>

        <hr class="my-10">
        <p class="mb-2 text-base">
          Collective work where <b>Michaël Robert-Angers</b>, <b>Anna Kerkhoff</b>, <b>Antoine Genest-Grégoire</b> and <b>Luc Godbout</b> have participated.
        </p>
        <p class="mb-2 text-base">
          The authors are actively collaborating to the researches of the <a
            class="underline"
            href="http://cffp.recherche.usherbrooke.ca/"
          >Chaire de recherche en fiscalité et en finances publiques</a>, whom they thank for their financial support which made the realisation of this tool possible..
        </p>
        <p class="text-base">
          Interactive tool conceived and realized by <b>François Lévesque</b> (<a
            class="underline"
            href="https://witify.io"
          >Witify</a>) and <b>Thomas Hurtut</b> (<a
            class="underline"
            href="http://www.professeurs.polymtl.ca/thomas.hurtut/"
          >Polytechnique Montréal</a>).
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import "intersection-observer";
import Scrollama from "vue-scrollama";
import Notice from "@/components/Notice";
import Viz from "@/components/Viz";
import debounce from "lodash/debounce";
import VizInteractive from "@/components/VizInteractive";
import { isDesktop } from "./services/responsive";
import { deepCopy } from "./services/utils";

export default {
	components: {
		Scrollama,
		Notice,
		Viz,
		VizInteractive
	},
	data () {
		return {
			isDesktop: isDesktop(),
			filters: {
				agglomerationAverage: true,
				showHighlights: true,
				showAmounts: true,
				showSelection: true,
				showSubstraction: false,
				showCumul: false,
				visible: [18,18],
				selected: [18,20],
				visibleCategories: [],
				selectedCategories: [],
				amounts: [],
				selectedScenarios: [0,1,2],
				firstAppear: true,
				tooltip: null,
				forceHighlight: []
			}
		};
	},
	mounted () {
		window.addEventListener("resize", this.onResize);
	},
	destroyed () {
		window.removeEventListener("resize", this.onResize);
	},
	methods: {
		onResize: debounce(function() {

			this.isDesktop = isDesktop();
			this.$refs.viz.onResize();
			if (this.isDesktop && this.$refs.vizInteractive) {
				this.$refs.vizInteractive.onResize();
			}
		}, 200),
		stepEnterHandler ({element, index, direction}) {

			if (element.getAttribute("data-step") === "end") {
				return;
			}

			let min = parseInt(element.getAttribute("data-min") || 18);
			let max = parseInt(element.getAttribute("data-max"));
      
			let tooltip = element.getAttribute("data-tooltip") || null;
      
			let showAmounts = element.getAttribute("data-amounts") !== "false";
			let showSelection = element.getAttribute("data-show-selection") !== "false";
			let showSubstraction = element.getAttribute("data-show-substraction") === "true";
			let showCumul = element.getAttribute("data-show-cumul") === "true";
      
			let selectedScenarios = element.getAttribute("data-scenarios") || "";
			selectedScenarios = selectedScenarios.split(",").filter(d => d != "").map(d => parseInt(d));
			if (selectedScenarios.length == 0) {
				selectedScenarios= [0,1,2];
			}
      
			let selectedCategories = element.getAttribute("data-category") || "";
			selectedCategories = selectedCategories.split(",").filter(d => d != "");
			if (selectedCategories.length == 0) {
				selectedCategories= ["revenu", "prestations", "benefices", "prelevements"];
			}
      
			let visibleCategories = this.filters.visibleCategories;
			selectedCategories.forEach(c => {
				if (visibleCategories.indexOf(c) === -1) {
					visibleCategories.push(c);
				}
			});
      
			visibleCategories = element.getAttribute("data-visible-category") || "";
			visibleCategories = visibleCategories.split(",").filter(d => d != "");
			if (visibleCategories.length == 0) {
				visibleCategories= this.filters.visibleCategories;
			}
      
			if (tooltip != null) {
				tooltip = tooltip.split(",");
			}
      
			let forceHighlight = element.getAttribute("data-force-highlight") || "";
			forceHighlight = forceHighlight.split(",").filter(d => d != "");
      
			let filters = deepCopy(this.filters);
      
			filters.firstAppear = false;
			filters.tooltip = tooltip;
			filters.selected = [min,max];
			filters.visible = [18,max];
			filters.selectedScenarios = selectedScenarios;
			filters.visibleCategories = visibleCategories;
			filters.selectedCategories = selectedCategories;
			filters.showAmounts = showAmounts;
			filters.showSelection = showSelection;
			filters.showSubstraction = showSubstraction;
			filters.showCumul = showCumul;
			filters.forceHighlight = forceHighlight;
      
			this.filters = filters;
		}
	}
};
</script>

<style>

</style>
